module.exports = __webpack_public_path__ + "img/icon-tri-updatetrivia.ae2072bc.png";